import React from 'react';
import I18n from 'app/i18n';
import ChangedProfileFields from 'app/components/auth/ChangedProfileFields';
import {changeNick} from './user_reset_popup';
import {inject, observer} from 'mobx-react';
import {UserStore} from 'app/store/UserStore';
import ChangePassword from 'app/components/my_profile/change_password';
import Delete from 'app/utils/Delete';
import {toastSuccess, toastErrorNotify} from 'app/components/toasts/liteToast';
import {modalConfirm} from 'app/utils/modals/popups';
import SteamInformation from 'app/components/steam/SteamInformation';
import BattlenetInformation from 'app/components/battlenet/BattlenetInformation';

interface Props {
    userStore?: UserStore
}

@inject('userStore')
@observer
export default class UserInformation extends React.Component<Props> {
    handleTelegramConnect = (): void => {
        modalConfirm(I18n.t('telegram.labels.connect_instruction'), () => {
            window.open('https://t.me/egb_live_bot', '_blank', 'noopener,noreferrer');
        });
    };

    handleTelegramDisconnect = (): void => {
        modalConfirm(I18n.t('telegram.labels.disconnect_question'), () => {
            this.executeTelegramDisconnect();
        });
    };

    executeTelegramDisconnect = (): void => {
        new Delete({url: '/telegram/disconnect'})
            .execute()
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    toastSuccess(data.message);
                    this.props.userStore.updateProfile();
                } else {
                    toastErrorNotify(data.error || I18n.t('telegram.errors.failed_to_disconnect'));
                }
            })
            .catch(() => {
                toastErrorNotify(I18n.t('telegram.errors.failed_to_disconnect'));
            });
    };

    render(): React.ReactNode {
        const {
            name,
            user_id,
            telegram_user_id,
            telegram_username,
            steam_account,
            battlenet_account,
            can_change_password: canChangePassword,
            registered_via_steam: registeredViaSteam,
            registered_via_battlenet: registeredViaBattlenet
        } = this.props.userStore.user;
        const isTelegramConnected = Boolean(telegram_user_id);

        return <>
            <div className="profile__info-user-wrap">
                <dl className="profile__info-user">
                    <dt>{I18n.t('nickname')}</dt>
                    <dd>{name} (#{user_id})</dd>
                </dl>
                <div className="profile__btn">
                    <button className="btn" onClick={changeNick}>{I18n.t('change')}</button>
                </div>
            </div>
            <div className="profile__info-user-wrap">
                <dl className="profile__info-user">
                    <dt>{I18n.t('telegram.labels.telegram_bot')}</dt>
                    <dd>
                        {isTelegramConnected && `${telegram_username ? `@${telegram_username}` : ''}`}
                    </dd>
                </dl>
                <div className="profile__btn">
                    {isTelegramConnected
                        ? <button className="btn" onClick={this.handleTelegramDisconnect}>
                            {I18n.t('telegram.labels.disconnect')}
                        </button>
                        : <button className="btn" onClick={this.handleTelegramConnect}>
                            {I18n.t('telegram.labels.connect')}
                        </button>}
                </div>
            </div>
            <SteamInformation
                steamId={steam_account.steam_id}
                steamUsername={steam_account.steam_username}
                steamAvatarUrl={steam_account.steam_avatar_url}
                steamLinkedAt={steam_account.steam_linked_at}
                registeredViaSteam={registeredViaSteam}
            />
            <BattlenetInformation
                battlenetId={battlenet_account.battlenet_id}
                battletag={battlenet_account.battlenet_battletag}
                battlenetLinkedAt={battlenet_account.battlenet_linked_at}
                registeredViaBattlenet={registeredViaBattlenet}
            />
            {canChangePassword && <div className="profile__user">
                <ChangePassword/>
            </div>}
            <ChangedProfileFields {...this.props.userStore.user}/>
        </>;
    }
}
